
import { defineComponent } from "vue";
import EntityRelationshipsList from "@/components/page/entity-relationships/list.vue";
export default defineComponent({
  name: "entity-relationships-retailer-exporter",
  components: {
    EntityRelationshipsList,
  },
});
